import React from "react";
import styled from "styled-components";
import { Content, Container } from "../../pages/Template";
import { getURLParam, Tabs } from "../../lib";
import { setWindowTitle, device, isMobile } from "../../helpers";
import {
    LoginForm,
    RegisterForm,
    ResetPasswordForm,
} from "../../components/Forms";

const LOGIN_TAB = "loginForm";
const REGISTER_TAB = "registerForm";
const RESET_PASSWORD_TAB = "resetPasswordForm";

const TabContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 40px auto 0 auto;
    width: 60%;

    @media ${device.phone} {
        margin: 20px auto 0 auto;
        width: 90%;
    } ;
`;

type Tab = "loginForm" | "registerForm" | "resetPasswordForm";
function getActiveTab() {
    const tab = getURLParam("tab");

    if (tab === "register") {
        return "registerForm";
    } else if (tab === "login") {
        return "loginForm";
    }

    return "loginForm";
}

type Props = {
    location: {
        state: any;
    };
};
type State = {
    activeTab: Tab;
};

export class LoginPage extends React.Component<Props, State> {
    static paths = ["/app/login"];
    private titles = [LOGIN_TAB, REGISTER_TAB, RESET_PASSWORD_TAB];

    constructor(props: Props) {
        super(props);
        this.state = {
            activeTab: getActiveTab(),
        };
    }

    onTabSelect = (activeTab: string) =>
        this.setState({ activeTab: activeTab as Tab });

    componentDidMount() {
        setWindowTitle("لاگن");
    }

    render() {
        const { activeTab } = this.state;

        return (
            <Content isLandingPage={isMobile()}>
                <Container width="800px">
                    <Tabs
                        titles={this.titles}
                        activeTab={activeTab}
                        onSelect={this.onTabSelect}
                    >
                        {
                            <TabContainer>
                                {activeTab === LOGIN_TAB && <LoginForm />}

                                {activeTab === REGISTER_TAB && (
                                    <RegisterForm redirect={true} />
                                )}

                                {activeTab === RESET_PASSWORD_TAB && (
                                    <ResetPasswordForm />
                                )}
                            </TabContainer>
                        }
                    </Tabs>
                </Container>
            </Content>
        );
    }
}
